import React from "react";
import {
  DisplayLinks
} from "../../_metronic/_partials";
export function DLinks(props) {
  return <DisplayLinks {...props} />;
}
